module.exports = __webpack_public_path__ + "img/reset_pass2.ee9f06d5.jpg";